import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import ConfigModule from "@/store/modules/ConfigModule";

config.rawError = true;

const store = createStore({
  modules: {
    ConfigModule,
  },
});

export default store;
